import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, HideFromAssemblyInstructionsComponent, OuterMeasurementsComponent, PartKey, RangeComponent, HideInSeeThroughSystemComponent, DistanceMeasurementComponent, TVComponent, NonBehaviorDeleteComponent, NonDuplicatableComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, DraggableComponent, HierarchyUtils } from '@inter-ikea-core/core';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
export const eketComponentResolver = (_coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.EKET_FRAME,
        ProductType.EKET_MEDIA_FRAME,
        ProductType.EKET_DOOR,
        ProductType.EKET_LEG,
        ProductType.EKET_SUSPENSION_RAIL,
        ProductType.EKET_CONNECTION_FITTING
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.EKET_FRAME,
        ProductType.EKET_MEDIA_FRAME,
        ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM,
        ProductType.EKET_LEG,
        ProductType.TV
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.EKET_FRAME,
        ProductType.EKET_MEDIA_FRAME,
        ProductType.EKET_LEG
    ]);
    const isFrameWithGlassDoorAssembly = isOfType([ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM]);
    const isTV = isOfType([ProductType.TV, ProductType.TV_WITH_FOOT]);
    const isFrame = isOfType([
        ProductType.EKET_FRAME,
        ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM,
        ProductType.EKET_MEDIA_FRAME
    ]);
    const shouldBeRemovedFromAssemblyImages = isOfType([]);
    const ignoredProductPartKeys = [PartKey.FRAME]; // Ignore the frame inside the frame with glass door assembly
    const shouldExcludeProduct = (entity) => {
        if (entity.hasComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID) &&
            ignoredProductPartKeys.includes(entity.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID).partKey)) {
            return true;
        }
        return false;
    };
    const componentBuilder = {
        build: (entity) => {
            if (isFrameWithGlassDoorAssembly(entity)) {
                HierarchyUtils.children(entity).forEach(e => {
                    e.removeComponent(ComponentIds.FRAME_COMPONENT_ID);
                    e.removeComponent(ComponentIds.CONNECTORS_COMPONENT_ID);
                });
            }
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (isPlannerProduct(entity) && !shouldExcludeProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
                entity.addComponent(new RangeComponent('eket'));
            }
            if (isFrame(entity)) {
                entity.addComponent(new DraggableComponent());
                entity.addComponent(new HideInSeeThroughSystemComponent());
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (isTV(entity)) {
                entity.addComponent(new TVComponent());
                entity.addComponent(new NonBehaviorDeleteComponent());
                entity.addComponent(new NonDuplicatableComponent());
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
                entity.addComponent(new RangeComponent('eket'));
            }
            if (shouldBeRemovedFromAssemblyImages(entity)) {
                entity.addComponent(new HideFromAssemblyInstructionsComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=eketComponentResolver.js.map